import { startInversion, undoInversion } from 'src/util/canvas'
import { dxmEngravedOfCatchFace } from 'src/features/dxm/drawer/rightThrow/glove/back/label'
import { canvasResetter } from 'src/util/canvas'
import { laceOfKnots } from 'src/features/dxm/drawer/rightThrow/catcher/front/lace/knots'
import { laceOfBackOfArroundWebDrawer } from 'src/features/dxm/drawer/rightThrow/catcher/front/lace/arroundWeb'
import { webDrawer } from 'src/features/dxm/drawer/rightThrow/catcher/front/web'
import { catchFaceDrawer } from 'src/features/dxm/drawer/rightThrow/catcher/front/catchFace'
import { thumbMachi } from 'src/features/dxm/drawer/rightThrow/catcher/front/thumbMachi'
import { littleMachi } from 'src/features/dxm/drawer/rightThrow/catcher/front/littleMachi'
import { edgeDrawer } from 'src/features/dxm/drawer/rightThrow/catcher/front/edge'
import { stitch } from 'src/features/dxm/drawer/rightThrow/catcher/front/stitch'
import { laceDrawer } from 'src/features/dxm/drawer/rightThrow/catcher/front/lace'
import { State } from 'src/types'

export const dxmCanvasCatcherMittFrontLeftThrow = (ctx: CanvasRenderingContext2D, state: State, canvasWidth: number): void => {
  // リセット
  canvasResetter(ctx)
  startInversion(ctx, canvasWidth)

  laceOfKnots(ctx, state.lace.color, 0, 0)
  laceOfBackOfArroundWebDrawer(ctx, state)
  webDrawer(ctx, state)
  catchFaceDrawer(ctx, state)
  thumbMachi(ctx, state.thumbMachi?.color)
  littleMachi(ctx, state.littleMachi?.color)
  // edge(ctx, state.edge.color)
  edgeDrawer(ctx, state)
  stitch(ctx, state.stitch.color)
  laceDrawer(ctx, state)

  undoInversion(ctx, canvasWidth)
  // メーカー捕球面の刻印
  dxmEngravedOfCatchFace(ctx, state.catchFace, 0, 0)
}
